import { ReactNode } from 'react';

/** Inline spinner (dědí barvu a velikost textu). */
export function Spinner({ className = '' }: { className?: string }) {
    return <span className={`rc-spinner ${className}`.trim()} aria-hidden="true" />;
}

/**
 * Plynule animované rozbalení/sbalení (CSS grid-rows trik).
 * Obsah zůstává mounted — react-hook-form registrace polí přežívají sbalení.
 */
export function Collapse({ open, children }: { open: boolean; children: ReactNode }) {
    return (
        <div className={`rc-collapse${open ? ' rc-collapse--open' : ''}`} aria-hidden={!open}>
            <div className="rc-collapse__inner">{children}</div>
        </div>
    );
}

/** Kostra formuláře během načítání překladového katalogu. */
export function CheckoutSkeleton() {
    const input = (key: number) => (
        <div key={key}>
            <div className="rc-skeleton__bar rc-skeleton__bar--label" />
            <div className="rc-skeleton__bar rc-skeleton__bar--input" style={{ maxWidth: 420 }} />
        </div>
    );

    return (
        <div className="rc-checkout">
            <div className="rc-skeleton" aria-busy="true">
                <div className="rc-skeleton__bar rc-skeleton__bar--title" />
                {[1, 2, 3, 4].map(input)}
                <div className="rc-skeleton__bar rc-skeleton__bar--title" />
                {[5, 6, 7].map(input)}
            </div>
        </div>
    );
}

/**
 * Krátce zvýrazní pole, která byla právě předvyplněná (ARES/VIES autofill),
 * aby bylo vidět, co se změnilo. Inputy jsou uncontrolled (react-hook-form),
 * proto přímá práce s DOM přes id.
 */
export function flashInputs(ids: string[]): void {
    ids.forEach((id) => {
        const element = document.getElementById(id);
        if (!element) {
            return;
        }
        element.classList.remove('rc-flash');
        void element.offsetWidth; // restart animace
        element.classList.add('rc-flash');
        element.addEventListener('animationend', () => element.classList.remove('rc-flash'), { once: true });
    });
}
